/* Progressive motion: content stays visible without JS, observers or animation.
   Only offscreen editorial content enters; shopping controls stay immediate. */
(function () {
  'use strict';

  if (window.__dsrcvMotionInitialized || !window.IntersectionObserver || !Element.prototype.animate) return;
  window.__dsrcvMotionInitialized = true;

  var selectors = [
    '#main .SectionHeader',
    '#main .HomeFeaturedRailSection .ProductListWrapper',
    '#main .FeatureText__Content',
    '#main .FeatureText__ImageWrapper',
    '#main .ProductList--grid:not([data-home-featured-rail]) > .Grid__Cell',
    '#main .ArticleList .ArticleItem',
    '#main .ProductMeta__Description',
    '#main .PageContent',
    '#main .Faq__Item',
    '.Footer .Footer__Block'
  ].join(',');
  // Campaign artwork and collection listings stay still while scrolling.
  var excluded = '.HomeSlideshow, .Drawer, .Modal, .Popover, .pswp, form, [data-home-featured-rail], .ProductForm, .template-collection [data-native-collection], .template-collection [data-section-type="collection"]';
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = window.navigator.connection;
  var seen = new WeakSet();
  var pending = new Set();
  var active = new Map();
  var changedRoots = new Set();
  var frame = null;
  var observer = null;
  var mutations = null;
  var stopped = false;

  function enabled() {
    return !stopped && !motionQuery.matches && !(connection && connection.saveData);
  }

  function finish(element) {
    seen.add(element);
    pending.delete(element);
    if (observer) observer.unobserve(element);
    var animation = active.get(element);
    if (animation) {
      active.delete(element);
      animation.cancel();
    }
  }

  function animate(element, delay) {
    finish(element);
    if (!enabled() || element.contains(document.activeElement)) return;
    try {
      // The independent translate property preserves carousel/hover transforms.
      var animation = element.animate([
        { opacity: 0.55, translate: '0 18px' },
        { opacity: 1, translate: '0 0' }
      ], { duration: 620, delay: delay, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'none' });
      active.set(element, animation);
      animation.finished.then(function () {
        if (active.get(element) === animation) active.delete(element);
      }, function () {
        if (active.get(element) === animation) active.delete(element);
      });
    } catch (_) {
      // A motion failure must leave the normal content and controls available.
      active.delete(element);
    }
  }

  function register(element) {
    if (!enabled() || seen.has(element) || pending.has(element) || element.closest(excluded)) return;
    // Never compete with a configured Prestige reveal or animate nested groups.
    if (window.theme && window.theme.showElementStaggering && element.matches('.Grid__Cell, .ArticleItem')) return;
    if (element.parentElement && element.parentElement.closest(selectors)) return;
    if (element.querySelector('form, .ProductForm, .Product__Info, .Product__Gallery')) return;
    var rect = element.getBoundingClientRect();
    if (rect.width && rect.height && rect.top < window.innerHeight) {
      seen.add(element);
      return;
    }
    pending.add(element);
    observer.observe(element);
  }

  function scan(root) {
    if (!enabled()) return;
    if (root.nodeType === 1 && root.matches(selectors)) register(root);
    root.querySelectorAll(selectors).forEach(register);
  }

  function onIntersection(entries) {
    var cardIndex = 0;
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || !pending.has(entry.target)) return;
      var element = entry.target;
      var rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height || element.closest('[hidden], [aria-hidden="true"]')) return;
      var delay = element.matches('.Grid__Cell, .ArticleItem') ? Math.min(cardIndex++ * 45, 135) : 0;
      animate(element, delay);
    });
  }

  function onIntent(event) {
    var element = event.target;
    while (element && element.nodeType === 1) {
      if (pending.has(element) || active.has(element)) finish(element);
      element = element.parentElement;
    }
  }

  function suspend() {
    if (observer) observer.disconnect();
    if (mutations) mutations.disconnect();
    if (frame !== null) window.cancelAnimationFrame(frame);
    frame = null;
    changedRoots.clear();
    pending.clear();
    active.forEach(function (animation) { animation.cancel(); });
    active.clear();
  }

  function start() {
    suspend();
    if (!enabled()) return;
    try {
      observer = new IntersectionObserver(onIntersection, { rootMargin: '0px 0px 24px 0px', threshold: 0 });
      scan(document);
      mutations = new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) { if (node.nodeType === 1) changedRoots.add(node); });
          record.removedNodes.forEach(function (node) {
            pending.forEach(function (element) { if (node === element || node.contains(element)) finish(element); });
            active.forEach(function (_, element) { if (node === element || node.contains(element)) finish(element); });
          });
        });
        if (changedRoots.size && frame === null) frame = window.requestAnimationFrame(function () {
          frame = null;
          changedRoots.forEach(function (root) { if (root.isConnected) scan(root); });
          changedRoots.clear();
        });
      });
      var main = document.getElementById('main');
      if (main) mutations.observe(main, { childList: true, subtree: true });
    } catch (_) { suspend(); }
  }

  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('pointerdown', onIntent, true);
  document.addEventListener('shopify:section:load', start);
  if (motionQuery.addEventListener) motionQuery.addEventListener('change', start);
  else motionQuery.addListener(start);
  if (connection && connection.addEventListener) connection.addEventListener('change', start);
  window.addEventListener('pagehide', function () { stopped = true; suspend(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { stopped = false; start(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
